import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { autoPlay } from "react-swipeable-views-utils";
export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            margin: '12px 8px',
            flexDirection: 'column',
            
            justifyContent: 'center',
            alignItems: 'center',
        },
        img: {
            width: 269.61,
            height: 131.75,
            marginBottom: 8,
        },
        heading: {
            position: 'static',
            fontSize: 14,
            fontWeight: 500,
        },
        description: {
            fontSize: 12,
            opacity: 0.7,
            marginLeft: 36,
            marginRight: 35,
            marginTop: 8,
            textAlign: 'center',
        },
        pending: {
            color: '#36c5db',
            fontSize: 16,
            fontWeight: 900,
            marginTop: 4,
        },
        button: {
            
            textTransform: 'capitalize',
            padding: 10,
            fontSize: 13,
            opacity: 0.8,
            width: 132,
            height: 42,
            marginLeft: 9,
            borderRadius: 20,
            fontWeight: 500,
            borderColor: '#0e4bb4',
            marginTop: 16,
            marginBottom: 16,
        },
    }),
);